import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Product_Info_Card_3 from "../../Common-Component/product_info_card_3/Product_Info_Card_3";
import Common_Heading_Holder from "../../Common-Component/common_heading_holder/Common_Heading_Holder";
import "./Similar_Products.css";
import { CategoryProduct } from "../../../utils/apis/Product/Product";

const Similar_Products = ({ product }) => {
  const [similar, setSimilar] = useState([]);

  const fetchSimilarProducts = async () => {
    if (!product?.category_id) return;

    const res = await CategoryProduct();

    if (res?.success) {
      const category = res.data.find((cat) => cat.id === product.category_id);

      if (!category) return;

      const filtered = category.products.filter(
        (item) => item.id !== product.id
      );

      setSimilar(filtered);
    }
  };

  useEffect(() => {
    fetchSimilarProducts();
  }, [product]);

  return (
    <section className="Similar_Products">
      <div className="container">
        <Common_Heading_Holder headingText={"Similar Products"} />

        <div className="more_prods_div">
          <Swiper
            spaceBetween={15}
            className="common_swiper"
            breakpoints={{
              0: { slidesPerView: 1.5 },
              480: { slidesPerView: 2.5 },
              768: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
          >
            {similar?.map((item) => (
              <SwiperSlide key={item.id}>
                <Product_Info_Card_3
                  product={item}
                  // product={{
                  //   product_name: item.name,
                  //   img: item.image1,
                  //   selling_price: item?.product_variants?.[0]?.s_price,
                  //   mrp: item?.product_variants?.[0]?.mrp,
                  // }}
                  product_id={item.id}
                  showQty
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Similar_Products;
